// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3QNej","requiredAsterisk":"Info_requiredAsterisk__1Ojsz"};